import * as React from "react";
import PropTypes from "prop-types";
import PullToRefreshLabelBar from "./PullToRefreshLabelBar";
import PullToRefreshOffstageIndicator from "./PullToRefreshOffstageIndicator";

export default class PullToRefresh extends React.PureComponent {
  static propTypes = {
    // The target element that we should track touch and scroll events on.
    target: PropTypes.object, // HTMLElement

    // When disabled, we don't do anything if you pull to refresh again. This
    // should be set to true once the pull-to-refresh has been "handled" and a
    // network request is inflight, so that you don't queue up a ton of network
    // requests for the same resource.
    //
    // Additionally, for non-offstage (floating label bar), we hide the bar when
    // disabled is true.
    disabled: PropTypes.bool,

    // Whether to use an offstage arrow or a floating bar. We use an offstage
    // arrow on iOS because we can leverage iOS's overscroll there. On Android
    // we use the floating bar at the top (dark blue, says 'PULL TO REFRESH')
    offstage: PropTypes.bool,

    // How many pixels you have to drag for the bar to show up on the top.
    // Doesn't affect the offstage arrow.
    dragThreshold: PropTypes.number,

    // How many pixels you have to drag for the pull-to-refresh event to occur.
    // Doesn't affect the offstage arrow.
    activationThreshold: PropTypes.number,

    // This gets called once they've pulled enough that we should refresh. It
    // won't get called if our disabled prop is true (to be consistent with
    // Polymer behavior.)
    onActivate: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    dragThreshold: 20,
    activationThreshold: 50,
    offstage: false,
  };

  render() {
    const {
      target,
      disabled,
      offstage,
      dragThreshold,
      activationThreshold,
      onActivate,
    } = this.props;

    return offstage ? (
      <PullToRefreshOffstageIndicator
        target={target}
        disabled={disabled}
        activationThreshold={activationThreshold}
        onActivate={onActivate}
      />
    ) : (
      <PullToRefreshLabelBar
        target={target}
        disabled={disabled}
        dragThreshold={dragThreshold}
        activationThreshold={activationThreshold}
        onActivate={onActivate}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/index.jsx